"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Label = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Label"));
var _TypeAhead = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/TypeAhead"));
var _AutocompleteItem = _interopRequireDefault(require("../AutocompleteItem"));
var _AutocompleteUtils = require("./AutocompleteUtils");
var styles = {
  "modal-group-input-user": "Autocomplete__modal-group-input-user__1gHeh",
  "modalGroupInputUser": "Autocomplete__modal-group-input-user__1gHeh",
  "modal-autocomplete": "Autocomplete__modal-autocomplete__2tp86",
  "modalAutocomplete": "Autocomplete__modal-autocomplete__2tp86",
  "wrapper": "Autocomplete__wrapper__QZr4y",
  "autocomplete-input": "Autocomplete__autocomplete-input__3hVJV",
  "autocompleteInput": "Autocomplete__autocomplete-input__3hVJV"
}; 
require('./Autocomplete.css');
var Autocomplete = function Autocomplete(_ref) {
  var isUserListLoading = _ref.isUserListLoading,
    onAddIdentity = _ref.onAddIdentity,
    onSearch = _ref.onSearch,
    loggedUserId = _ref.loggedUserId;
  var identitiesPerQuery = 100;
  var defaultRoleId = 'viewer';
  var searchUser = (0, _AutocompleteUtils.searchUserFactory)({
    onSearch: onSearch,
    loggedUserId: loggedUserId
  });
  var handleOnChange = function handleOnChange(event) {
    onAddIdentity({
      identity: event.value.identity,
      role: defaultRoleId
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.modalGroupInputUser,
    "data-test-id": "modal-group-input-user"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.modalAutocomplete
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    className: "visually-hidden",
    htmlFor: "autocomplete-user"
  }, "User"), /*#__PURE__*/_react.default.createElement(_TypeAhead.default, {
    testId: "autocomplete-user",
    id: "autocomplete-user",
    autoComplete: "off",
    className: (0, _classnames.default)(styles.autocompleteInput, 'fs-block'),
    disabled: isUserListLoading,
    placeholder: "Add users and teams",
    optionsQuery: searchUser,
    name: "autocomplete",
    optionRenderer: _AutocompleteItem.default,
    itemsToFetch: identitiesPerQuery,
    onChange: handleOnChange,
    isClearedAfterSelect: true
  }))));
};
var _default = exports.default = Autocomplete;
//# sourceMappingURL=Autocomplete.js.map